import { LanguageSelectorProps } from "@omni/ui/components/LanguageSelector/languageSelector.props";
import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { set as setLocales } from "@/redux/modules/value/locales/locales.module";
import { Config } from "@/utils/config.utils";

import LanguageSelector from "./languageSelector.component";

export const LanguageSelectorContainer = ({
    layout,
    variant,
    color
}: LanguageSelectorProps) => {
    const dispatch = useThunkDispatch();

    useEffect(() => {
        dispatch(
            setLocales({
                current: Config.general.locale,
                languages: Config.languages
            })
        );
    }, [dispatch]);

    return (
        <LanguageSelector
            layout={layout || "default"}
            variant={variant}
            color={color}
        />
    );
};
